/* @flow */
import User from 'entities/User';

let hadWindowUser = false;

export function getWindowUser(): ?User {
  const { initialAppData: init } = window;
  // read on app init, so clear it away to prevent re-reading it when it's stale
  delete window.initialAppData;

  const userData = init && init.authenticated && init.userData;
  if (userData) {
    hadWindowUser = true;
    return User.fromJSON(userData);
  } else {
    return null;
  }
}

export function logIfUnexpected401() {
  if (hadWindowUser) {
    console.warn('Received 401 after finding a window user');
  }
}
